import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Button from "@mui/material/Button";

import { SCRIBE_GUIDE_COPY as COPY } from "./scribe-guide.copy";

interface ScribeGuideButtonProps {
  onClick: () => void;
  /** `small` sits beside the other small header buttons, at the same 14px they use. */
  size?: "small" | "medium";
}

/** The one "How Ambient Scribe works" button, so every surface that offers the guide looks the same. */
export default function ScribeGuideButton({
  onClick,
  size = "medium"
}: ScribeGuideButtonProps) {
  return (
    <Button
      variant="outlined"
      size={size}
      startIcon={<HelpOutlineIcon />}
      onClick={onClick}
      sx={{
        flex: "none",
        // Its own height in any row: stretched to a tall neighbour, it became a 240px box.
        alignSelf: "center",
        whiteSpace: "nowrap",
        ...(size === "small" && { fontSize: "14px" })
      }}
    >
      {COPY.howScribeWorks}
    </Button>
  );
}
